import React, { useState } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import styles from "./RegistrarCuenta.module.css";
import { useNavigate } from "react-router-dom";
import sideImage from "../../src/assets/img/login/sky-home.svg";
import logo from "../assets/img/logos/sky-new-2020-seeklogo2.svg";
import BarraLoader from "../General/BarraLoader";
import ConfirmMessage from "../General/ConfirmMessage";

export const RegistroErroneo: React.FC = () => {
  const [codigo, setCodigo] = useState<string[]>(["", "", "", ""]);
  const [statusError, setStatusError] = useState("OK");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [imagenURI] = useState(logo);
  const [status, setStatus] = useState({
    show: false,
    color: "red",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async () => {};

  return (
    <>
      <Container className={styles.container}>
        <div className={styles["confirmMessage"]}>
          <ConfirmMessage
            status={statusError}
            message={message}
            showAlert={showAlert}
          />
        </div>

        {loading && <BarraLoader />}

        <Row className={styles["rowContainer"]}>
          <Col
            xs={12}
            sm={12}
            md={7}
            lg={7}
            xl={7}
            className={styles["registrarForm"]}
          >
            <Form className={styles.estiloForm}>
              <img src={imagenURI} className={styles.logo} alt="Logo" />
              <hr className={styles["line"]} />

              <Row>
                <h4
                  className={
                    "text-2xl text-center " + styles["textGradient"] + " mb-2"
                  }
                >
                  <span>Registro</span>
                </h4>

                <div
                  onClick={() => navigate("/login")}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <svg
                    width="60"
                    height="60"
                    viewBox="0 0 125 125"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M62.5 15.4165C36.4966 15.4165 15.4166 36.4964 15.4166 62.4998C15.4166 88.5033 36.4966 109.583 62.5 109.583C88.5034 109.583 109.583 88.5033 109.583 62.4998C109.583 36.4964 88.5034 15.4165 62.5 15.4165ZM5.41663 62.4998C5.41663 30.9736 30.9737 5.4165 62.5 5.4165C94.0262 5.4165 119.583 30.9736 119.583 62.4998C119.583 94.0261 94.0262 119.583 62.5 119.583C30.9737 119.583 5.41663 94.0261 5.41663 62.4998ZM81.6605 43.3393C83.6131 45.2919 83.6131 48.4577 81.6605 50.4104L69.571 62.4998L81.6605 74.5893C83.6131 76.5419 83.6131 79.7077 81.6605 81.6604C79.7079 83.613 76.542 83.613 74.5894 81.6604L62.5 69.5709L50.4105 81.6604C48.4579 83.613 45.292 83.613 43.3394 81.6604C41.3868 79.7077 41.3868 76.5419 43.3394 74.5893L55.4289 62.4998L43.3394 50.4104C41.3868 48.4577 41.3868 45.2919 43.3394 43.3393C45.292 41.3867 48.4579 41.3867 50.4105 43.3393L62.5 55.4288L74.5894 43.3393C76.542 41.3867 79.7079 41.3867 81.6605 43.3393Z"
                      fill="#E62443"
                    />
                  </svg>
                </div>
              </Row>

              {/* Código de verificación */}
              <Row className="justify-content-center">
                <Col md={12} className="text-center">
                  <br></br>
                  <p>
                    Espera unos minutos y vuelve a intentarlo o puedes llamar a
                    los números de sky
                  </p>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            className={styles["imageContainer"]}
          >
            <img src={sideImage} className={styles["sideImage"]} alt="Side" />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RegistroErroneo;
